// Import model
import { UpdateSfSectionRequest } from '../models/UpdateSfSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateSfSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateSfSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateSfSectionRequest instance
   */
  static deserialize(json: string): UpdateSfSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateSfSectionRequest instance
   */
  static fromObject(obj: any): UpdateSfSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateSfSectionRequest');
    }


    const instance: UpdateSfSectionRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateSfSectionRequest instances
   */
  static deserializeArray(json: string): UpdateSfSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateSfSectionRequest instance to a JSON string
   */
  static serialize(instance: UpdateSfSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateSfSectionRequest instance to a plain object
   */
  static toObject(instance: UpdateSfSectionRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of UpdateSfSectionRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateSfSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
